/**
 * Returns true if given experience is HLS
 *
 * @param {object} experience Experience configuration
 * @returns {boolean}
 */
export default function isHlsExperience(experience = {}) {
  const media = experience.media || {};
  const videos = media.dwells || {};
  const video = Object.values(videos)[0];

  if (!video) {
    throw new Error("Experience is invalid: dwell video missing");
  }

  if (video.source && hasHls(video)) {
    return true;
  }

  if (experience.videoFormat === "hls" && hasHls(video)) {
    return true;
  }

  return false;
}

/**
 * Return true if given video dictionary contains an m3u8
 * playlist
 *
 * Example legacy input:
 * {
 *   "source": "https://cdn.vimeo.com/video_filename.m3u8"
 * }
 *
 * Example input:
 * {
 *   "hls": "https://cdn.vimeo.com/video_filename.m3u8",
 *   "240p": "https://cdn.vimeo.com/video_filename_240p.mp4",
 *   ...
 * }
 *
 * @param {object} video Collection of one or more video objects
 * @returns {boolean}
 */
function hasHls(video = {}) {
  const source = video.source || video.hls;

  return source.includes(".m3u8");
}
